import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6baffc3b&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=6baffc3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baffc3b",
  null
  
)

export default component.exports